var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRuleFaile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17C11.2091 17 13.2091 16.1046 14.6568 14.6568C16.1046 13.2091 17 11.2091 17 9C17 6.79088 16.1046 4.79088 14.6568 3.34314C13.2091 1.89543 11.2091 1 9 1C6.79088 1 4.79088 1.89543 3.34314 3.34314C1.89543 4.79088 1 6.79088 1 9C1 11.2091 1.89543 13.2091 3.34314 14.6568C4.79088 16.1046 6.79088 17 9 17Z",
    stroke: "#FF4F4F",
    strokeWidth: 1.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99998 7.86858L11.5454 5.32315L12.6768 6.45452L10.1314 8.99995L12.6768 11.5454L11.5454 12.6768L8.99998 10.1313L6.45457 12.6767L5.3232 11.5454L7.86861 8.99995L5.3232 6.45454L6.45457 5.32317L8.99998 7.86858Z",
    fill: "#FF4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuleFaile);
export default __webpack_public_path__ + "static/media/rule-faile.e37f116059155b019cf53cbf1e25420a.svg";
export { ForwardRef as ReactComponent };